import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Pagination — Pagination serveur (Phase 3.4)
 */
export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(0, page - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible);
  if (end - start < maxVisible) start = Math.max(0, end - maxVisible);

  for (let i = start; i < end; i++) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-1 py-4" data-testid="pagination">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page === 0}
        className="p-1.5 rounded-md border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed"
        data-testid="pagination-prev"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      {start > 0 && (
        <>
          <button onClick={() => onPageChange(0)} className="px-3 py-1 text-xs rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50">1</button>
          {start > 1 && <span className="text-gray-400 text-xs">…</span>}
        </>
      )}
      {pages.map(p => (
        <button
          key={p}
          onClick={() => onPageChange(p)}
          className={`px-3 py-1 text-xs rounded-md border transition-colors ${p === page ? 'bg-gray-900 text-white border-gray-900' : 'border-gray-200 text-gray-600 hover:bg-gray-50'}`}
          data-testid={`pagination-page-${p}`}
        >
          {p + 1}
        </button>
      ))}
      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="text-gray-400 text-xs">…</span>}
          <button onClick={() => onPageChange(totalPages - 1)} className="px-3 py-1 text-xs rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50">{totalPages}</button>
        </>
      )}
      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages - 1}
        className="p-1.5 rounded-md border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed"
        data-testid="pagination-next"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
